// extracted by mini-css-extract-plugin
export default {"body_styleDefault":"c-a_fw","body_styleRed":"c-a_fx"};